module.exports = __webpack_public_path__ + "static/img/bg_jp.83bd995.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-hour-2026-sale/bg_jp.png
// module id = aIuG
// module chunks = 2